<template>
  <div>
    <h1 class="my-2">{{title}}</h1>for Unprinted Certificates
    <v-dialog v-model="showReportDialog">
      <report-viewer
        :reportName="Report_Name"
        :dataUrl="Report_URL"
        ref="reportViewer"
        :printOnly="true"
      />
      </v-dialog>
    
    <v-row>
      <v-col>
        <v-card class="py-10 px-15">
          <v-card-text>
            <v-select
              outlined
              v-model="certType"
              :items="luItems"                                                              
              :item-text="item =>item.programId +': '+ item.programName"
              item-value="programId"
              label="Certificate Type"
            ></v-select>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="primary" text @click="certType == 'DNA' ? showTitleDialogFull() : showTitleDialog()">
              Print Certificates
            </v-btn>
            <v-btn color="primary" text @click="showLabelsDialog()">
              Print Labels
            </v-btn>
            <v-btn color="primary" text @click="markUnprintedAsPrinted()">
              Mark Printed
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor" title>
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="dark" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ReportViewer from "@/components/Admin/Reports/ReportViewer.vue";
import adminTitlingService from "@/services/admin/titlingService";
import lookupsService from "@/services/admin/lookupsService";
import { ProgramLookupInfo } from "@/types/admin/Lookup";
import { MetaNames } from "@/constants";

export default Vue.extend({
  components: { ReportViewer },
  name: "CertPrinting",
    data: function () {
        return {
            title: MetaNames.AdminCertificatePrinting,
            Report_Name: '',
            Report_URL: '',
            Report_Cert_Name: 'Asca.Api.Reports.rpt8110_Title_Certificate.rdlx',
            Report_CertFull_Name: 'Asca.Api.Reports.rpt8111_Title_Certificate_Full.rdlx',
            Report_Labels_Name: 'Asca.Api.Reports.rpt1210_Person_Label.rdlx',
            showReportDialog: false,
            certType: "",
            showMarkPrintedDialog: false,
            snackbar: false,
            snackbarColor: "green",
            snackbarText: "",
            luItems: [] as ProgramLookupInfo[],
        };
    },
  created: function () {
    this.reloadItems();
  },
  methods: {
    showTitleDialog: function (){   
      this.Report_Name = this.Report_Cert_Name;
      this.Report_URL = `/Admin/reports/certificates/${this.certType}/unprinted`;
      this.showReportDialog = true;
    },
    showTitleDialogFull: function (){
      this.Report_Name = this.Report_CertFull_Name;
      this.Report_URL = `/Admin/reports/certificates/${this.certType}/unprinted`;
      this.showReportDialog = true;
    },
    showLabelsDialog: function (){
      this.Report_Name = this.Report_Labels_Name;
      this.Report_URL = `/Admin/reports/certificates/${this.certType}/unprinted/contacts`;
      this.showReportDialog = true;
    },
    reloadItems: function () {
            this.$data.isLoading = true;
            lookupsService.getCertProgramList().then((res: ProgramLookupInfo[]) => {
                this.luItems = res.filter(p => p.isManual);
                this.$data.isLoading = false;

            });
            this.$data.isLoading = false;
        },
    toggleMarkPrintedDialog() {
      this.showMarkPrintedDialog = !this.showMarkPrintedDialog;
    },
    markUnprintedAsPrinted() {
      this.toggleMarkPrintedDialog();
      adminTitlingService
        .markUnprintedCertsPrinted(this.certType)
        .then((res) => {
            if (res.success) {
                this.snackbar = true;
                this.snackbarText = "Successfully marked certificates as printed";
                this.snackbarColor = "green";
            } else {
                this.snackbar = true;
                this.snackbarText = "Error occured while trying to mark certificates as printed";
                this.snackbarColor = "red";   
            }
        })
        .catch(() => {
            this.snackbar = true;
            this.snackbarText = "Error occured while trying to mark certificates as printed";
            this.snackbarColor = "red";   
        });
    },
  },
  watch: {
    showReportDialog(newVal: boolean) {
      if (!newVal) {
        this.showMarkPrintedDialog = true;
      }
    },
  },
});
</script>
